import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import ProductItem from 'Components/lto/commonOrder/ProductItem';
import BasicButton from 'Components/lto/common/BasicButton';
import Dialog from 'Components/common/Dialog';
import Checkbox from '@material-ui/core/Checkbox';
import Select from 'Components/lto/common/Select';
import {openNotification} from 'Actions/notification';
import BasicTextArea from 'Components/common/BasicTextArea';

import {
    getLtoPurchaseOrderHistoryDetails,
    getNotificationChannel,
    reminderNotification,
    cancelOrder,
} from 'Actions/ltoPurchaseOrder';

import {T} from 'Actions/translate';

// Icons
import {ArrowBackIos, AccessTime} from '@material-ui/icons';

class LtoPurchaesOrderHistoryDetails extends React.Component {
    state = {
        tfsOrders: [],
        scOrders: [],
        isOpenNotificationDialog: false,
        isMobilityNotification: true,
        isSMS: false,
        isEmail: false,
        phoneNumberList: [],
        phoneNumberId: '',
        defaultEmail: '',
        loading: false,
        notificationMethods: [],
        cancelOrderDialogOpened: false,
        currentCancelReason: '',
    };

    componentWillMount() {
        this.props
            .getLtoPurchaseOrderHistoryDetails(this.getSerialNumber())
            .then((res) => {
                if (res.payload.status === 'success' && res.payload.data) {
                    let tempPurchaesOrderObj = res.payload.data;
                    let tfsSku = [];
                    let scSku = [];
                    if (
                        tempPurchaesOrderObj.orderProducts &&
                        tempPurchaesOrderObj.orderProducts.length > 0
                    ) {
                        tempPurchaesOrderObj.orderProducts.forEach(
                            (orderItem) => {
                                if (orderItem.deliveryChannel === 'TFS') {
                                    tfsSku.push(orderItem);
                                } else if (orderItem.deliveryChannel === 'SC') {
                                    scSku.push(orderItem);
                                }
                            },
                        );
                    }
                    this.setState({
                        tfsOrders: tfsSku,
                        scOrders: scSku,
                    });
                }
            });
    }

    getSerialNumber = () => {
        let currentSerialNumber = '';
        if (
            this.props.location.state &&
            this.props.location.state.serialNumber
        ) {
            currentSerialNumber = this.props.location.state.serialNumber;
        }
        return currentSerialNumber;
    };

    goBack = () => {
        // this.props.setShipmentsSource({$set: true});
        this.props.history.goBack();
    };

    getOrderStatus = (orderStatus, ltoPurchaseOrderHistoryDetails) => {
        let orderStatusValue = '';
        if (orderStatus === 'To_Be_Confirmed') {
            orderStatusValue = 'lto_history_order_wait_cusotmer_confirm';
        } else if (orderStatus === 'Confirmed') {
            orderStatusValue = 'lto_history_order_cusotmer_confirm';
        } else if (orderStatus === 'Cancelled') {
            orderStatusValue = util.showCancelledOrderStatus(
                ltoPurchaseOrderHistoryDetails.cancelBy,
            );
        } else {
            orderStatusValue = 'lto_history_order_wait_cusotmer_confirm';
        }

        return orderStatusValue;
    };

    getOrderQuantity(isShipment) {
        const {ltoPurchaseOrderHistoryDetails} = this.props;
        let quantity = 0;

        ltoPurchaseOrderHistoryDetails.orderProducts &&
            ltoPurchaseOrderHistoryDetails.orderProducts.forEach((product) => {
                quantity += product.quantity;
            });

        return quantity;
    }

    showOrderProducts = (orderProducts) => {
        return (
            <ul>
                {orderProducts && orderProducts.length > 0
                    ? orderProducts.map((skuObj, skuIndex) => (
                          <li key={skuIndex}>
                              <ProductItem
                                  item={skuObj}
                                  orderType={skuObj.deliveryChannel}>
                                  <div className="price-box">
                                      <span className="price number-font price-font">
                                          <i className="rmb"></i>{' '}
                                          <b>
                                              {util.toMoney(
                                                  skuObj.discountPrice,
                                              )}
                                          </b>{' '}
                                          {T('porduct_discount_price')}
                                      </span>
                                      <span className="quantity">
                                          X{skuObj.quantity}
                                      </span>
                                  </div>
                              </ProductItem>
                          </li>
                      ))
                    : null}
            </ul>
        );
    };

    getOrderReceiptEmail = (orderReceiptEmailList) => {
        let orderReceiptEmails = '';
        if (orderReceiptEmailList && orderReceiptEmailList.length > 0) {
            orderReceiptEmails = orderReceiptEmailList.join(',');
        }

        return orderReceiptEmails;
    };

    gotoMyOrderList = (salesOrderNumber) => {
        this.props.history.push(`/myOrderDetail`, {
            fromLto: true,
            orderNumber: salesOrderNumber,
        });
    };

    resendNotification = (item) => {
        let params = {
            receiverTel: item.receiverTel,
            email: item.customerEmail ? item.customerEmail : '',
            shipTo: item.shipToNumber,
        };
        console.log(params);

        this.props.getNotificationChannel(params).then((res) => {
            if (
                res &&
                res.status === 'success' &&
                res.data &&
                res.data.length > 0
            ) {
                let resendNotificationData = [];
                let tempDefaultEmail = '';
                res.data.map((receiverItem, receiverIndex) => {
                    if (receiverItem.method === 'mail') {
                        tempDefaultEmail = receiverItem.receiver;
                    } else if (receiverItem.method === 'sms') {
                        resendNotificationData =
                            util.getPhoneNumberArr(receiverItem);
                    }
                });

                this.setState(
                    {
                        defaultEmail: tempDefaultEmail,
                        phoneNumberList: resendNotificationData,
                        orderNumber: item.number,
                        phoneNumber:
                            resendNotificationData.length > 0
                                ? resendNotificationData[0].name
                                : '',
                        phoneNumberId:
                            resendNotificationData.length > 0
                                ? resendNotificationData[0].id
                                : '',
                    },
                    () => {
                        this.setState({
                            isOpenNotificationDialog: true,
                        });
                    },
                );
            }
        });
    };

    handleCustomerConfirmationChannel = (params, value) => {
        const {
            phoneNumberList,
            emailList,
            phoneNumberId,
            defaultEmail,
            emailId,
        } = this.state;
        this.setState(
            {
                [params]: !value,
            },
            () => {
                const {isSMS, isEmail, notificationMethods, defaultEmail} =
                    this.state;
                let tempNotificationMethods = [];
                if (params === 'isSMS') {
                    if (isSMS) {
                        let isSMSObj = {
                            method: 'sms',
                            receiver: '',
                        };
                        if (phoneNumberList.length > 0) {
                            let currentPhoneObj = {};
                            phoneNumberList.forEach((phoneItem) => {
                                if (
                                    phoneNumberId &&
                                    phoneNumberId === phoneItem.id &&
                                    phoneItem.name
                                ) {
                                    currentPhoneObj = phoneItem;
                                }
                            });

                            isSMSObj.receiver = currentPhoneObj.name;
                        }
                        tempNotificationMethods.push(isSMSObj);
                        tempNotificationMethods =
                            tempNotificationMethods.concat(
                                this.state.notificationMethods,
                            );
                    } else {
                        const newNotificationMethods =
                            notificationMethods.filter(
                                (obj) => obj.method !== 'sms',
                            );
                        tempNotificationMethods = newNotificationMethods;
                    }
                }

                if (params === 'isEmail') {
                    if (isEmail) {
                        let isEmailObj = {
                            method: 'mail',
                            receiver: '',
                        };

                        if (defaultEmail) {
                            isEmailObj.receiver = defaultEmail;
                        }
                        tempNotificationMethods.push(isEmailObj);
                        tempNotificationMethods =
                            tempNotificationMethods.concat(
                                this.state.notificationMethods,
                            );
                    } else {
                        const newNotificationMethods =
                            notificationMethods.filter(
                                (obj) => obj.method !== 'mail',
                            );
                        tempNotificationMethods = newNotificationMethods;
                    }
                }

                this.setState({
                    notificationMethods: tempNotificationMethods,
                });
            },
        );
    };

    resendNotificationHandle = () => {
        const {orderNumber, notificationMethods} = this.state;

        if (notificationMethods.length > 0) {
            let emptySmsFlag = false;
            notificationMethods.map((notificationItem, notificationIndex) => {
                if (
                    notificationItem.method === 'sms' &&
                    !notificationItem.method
                ) {
                    emptySmsFlag = true;
                }
            });
            if (emptySmsFlag) {
                this.props.openNotification(
                    T('customer_confirmation_channel_checked_sms_not_empty'),
                    'danger',
                );
                this.resetResentNotificationParam();
            } else {
                this.props
                    .reminderNotification({
                        number: orderNumber,
                        notificationMethods: notificationMethods,
                    })
                    .then((res) => {
                        if (res && res.status === 'success') {
                            this.props.openNotification(
                                T('lto_history_list_notification_send_success'),
                                'success',
                            );
                        }

                        this.resetResentNotificationParam();
                    });
            }
        } else {
            this.resetResentNotificationParam();
            this.props.openNotification(
                T('lto_history_detail_resend_channel_is_not_empty'),
                'danger',
            );
        }
    };

    resetResentNotificationParam = () => {
        this.setState({
            orderNumber: '',
            notificationMethods: [],
            isOpenNotificationDialog: false,
            phoneNumberList: [],
            defaultEmail: '',
            isSMS: false,
            isEmail: false,
            phoneNumberId: '',
        });
    };

    closeNotificationDialog = () => {
        this.resetResentNotificationParam();
    };

    openCancelOrderDialog = (myOrderItemDetail, e) => {
        let orderId = myOrderItemDetail.number;
        if (orderId) {
            this.setState({cancelOrderDialogOpened: true});
        } else {
            this.props.openNotification(T('order_does_not_exist'), 'danger');
        }
    };

    dialogDidClose = (dialog) => {
        this.state[dialog] && this.setState({[dialog]: false});
    };

    cancelOrderHandle = () => {
        const {ltoPurchaseOrderHistoryDetails} = this.props;
        const {currentCancelReason} = this.state;
        let orderId = ltoPurchaseOrderHistoryDetails.number;
        if (orderId) {
            if (currentCancelReason && currentCancelReason.length > 90) {
                this.props.openNotification(
                    T('notification_cancel_reason_not_exceed_90'),
                    'danger',
                );
            } else {
                this.props
                    .cancelOrder(
                        {number: orderId, cancelReason: currentCancelReason},
                        (res) => {
                            if (res.status === 'success') {
                                this.props.openNotification(
                                    T(
                                        'notification_successfully_cancel_the_order',
                                    ),
                                    'success',
                                );

                                this.setState(
                                    {cancelOrderDialogOpened: false},
                                    () => {
                                        this.props.history.replace(
                                            '/purchase/ltoHistoryList',
                                        );
                                    },
                                );
                            } else if (
                                res.status === 'integration_error' &&
                                res.message === 'order_has_confirmed'
                            ) {
                                this.props.openNotification(
                                    T('order_has_confirmed'),
                                    'danger',
                                );
                            } else {
                                this.props.openNotification(
                                    T('notification_order_cancellation_failed'),
                                    'success',
                                );
                            }
                        },
                    )
                    .catch((err) => {
                        console.log('err', err);
                        this.setState({
                            cancelOrderDialogOpened: false,
                            currentCancelReason: '',
                        });
                        if (
                            err.status === 'integration_error' &&
                            err.message === 'order_has_confirmed'
                        ) {
                            this.props.openNotification(
                                T('order_has_confirmed'),
                                'danger',
                            );
                        }
                    });
            }
        } else {
            this.props.openNotification(T('order_does_not_exist'), 'danger');
        }
    };

    closeCancelOrder = () => {
        this.setState({cancelOrderDialogOpened: false});
    };

    handleOnInput = (name, value) => {
        this.setState({currentCancelReason: value});
    };

    render() {
        const {
            tfsOrders,
            scOrders,
            isOpenNotificationDialog,
            isMobilityNotification,
            isSMS,
            isEmail,
            phoneNumberId,
            phoneNumberList,
            defaultEmail,
            loading,
            cancelOrderDialogOpened,
            currentCancelReason,
        } = this.state;
        const {ltoPurchaseOrderHistoryDetails} = this.props;

        return (
            <div className="pre-purchase-orderHistory-details-container">
                <div className="header-wrap">
                    <div className="pre-purchase-orderHistory-details-header container-max-width is-fixed">
                        <a className="go-back" onClick={this.goBack}>
                            <ArrowBackIos />
                        </a>
                        {T('lto_history_detail')}
                    </div>
                </div>

                <div className="detail-content">
                    <div className="pre-purchase-orderHistory-detail-card">
                        <div className="card-content">
                            <div className="perOrder-item-title">
                                <div className="title-item">
                                    <div className="left">
                                        {ltoPurchaseOrderHistoryDetails.orderStatus ===
                                            'Confirmed' &&
                                        ltoPurchaseOrderHistoryDetails.eoneOrderList &&
                                        ltoPurchaseOrderHistoryDetails
                                            .eoneOrderList.length > 0 ? (
                                            <div className="eone-order-list">
                                                <ul>
                                                    {ltoPurchaseOrderHistoryDetails.eoneOrderList.map(
                                                        (
                                                            eoneItem,
                                                            eoneInde,
                                                        ) => (
                                                            <li key={eoneInde}>
                                                                <div className="eone-order-type">
                                                                    {
                                                                        eoneItem.orderType
                                                                    }
                                                                </div>
                                                                <div
                                                                    className="sales-order-number"
                                                                    onClick={() =>
                                                                        this.gotoMyOrderList(
                                                                            eoneItem.salesOrderNumber,
                                                                        )
                                                                    }>
                                                                    {
                                                                        eoneItem.salesOrderNumber
                                                                    }
                                                                </div>
                                                            </li>
                                                        ),
                                                    )}
                                                </ul>
                                            </div>
                                        ) : (
                                            <div className="ready-payment-style">
                                                {
                                                    ltoPurchaseOrderHistoryDetails.number
                                                }
                                            </div>
                                        )}
                                    </div>
                                    <div className="right">
                                        <div className="order-status">
                                            {T(
                                                this.getOrderStatus(
                                                    ltoPurchaseOrderHistoryDetails.orderStatus,
                                                    ltoPurchaseOrderHistoryDetails,
                                                ),
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="title-item time-container">
                                    <div className="left">
                                        <div className="content-left">
                                            {T('lto_history_list_submit_time')}
                                        </div>
                                        <div className="content-right">
                                            {
                                                ltoPurchaseOrderHistoryDetails.createTime
                                            }
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="content-right">
                                            {ltoPurchaseOrderHistoryDetails.orderStatus ===
                                                'To_Be_Confirmed' && (
                                                <div className="right">
                                                    <label className="expiration-time-label">
                                                        {T(
                                                            'lto_history_detail_expiration_time',
                                                        )}
                                                    </label>
                                                    <span className="clock-icon">
                                                        <AccessTime />
                                                    </span>
                                                    {
                                                        ltoPurchaseOrderHistoryDetails.retentionTime
                                                    }{' '}
                                                    {T(
                                                        'lto_history_detail_23_59_hour_expiration',
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {ltoPurchaseOrderHistoryDetails.orderStatus ===
                                    'Confirmed' && (
                                    <div className="confirmed-time">
                                        <div className="confirmed-time-label">
                                            {T(
                                                'lto_history_detail_confirm_time',
                                            )}
                                        </div>
                                        {
                                            ltoPurchaseOrderHistoryDetails.confirmedTime
                                        }
                                    </div>
                                )}
                            </div>
                            {ltoPurchaseOrderHistoryDetails.orderStatus ===
                                'Confirmed' && (
                                <div className="item-double-normal">
                                    {/* <div className="left">
                                        <div className="content-left">
                                            {T('lto_history_list_st_number')}
                                        </div>
                                        <div className="content-right">
                                            {
                                                ltoPurchaseOrderHistoryDetails.shipToNumber
                                            }
                                        </div>
                                    </div> */}
                                    <div className="right">
                                        <div className="content-left">
                                            {T(
                                                'lto_history_detail_preorder_number',
                                            )}
                                        </div>
                                        <div className="content-right lto-number">
                                            {
                                                ltoPurchaseOrderHistoryDetails.number
                                            }
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="st-content-double-noraml">
                                <label className="name-label">
                                    {T('lto_history_list_customer_account')}
                                </label>
                                <span className="name-value">
                                    {ltoPurchaseOrderHistoryDetails.customer}{' '}
                                    {
                                        ltoPurchaseOrderHistoryDetails.customerEmail
                                    }
                                </span>
                            </div>

                            <div className="item-double-normal po-number-item">
                                <div className="left">
                                    <div className="content-left">
                                        {T('lto_history_list_po_number')}
                                    </div>
                                    <div className="content-right">
                                        {ltoPurchaseOrderHistoryDetails.poNumber
                                            ? ltoPurchaseOrderHistoryDetails.poNumber
                                            : T('-')}
                                    </div>
                                </div>
                            </div>

                            {ltoPurchaseOrderHistoryDetails.promotionCodes ? (
                                <div className="st-content-double-noraml">
                                    <label className="name-label">
                                        {T(
                                            'lto_history_detail_promotion_codes',
                                        )}
                                    </label>
                                    <span className="name-value">
                                        {
                                            ltoPurchaseOrderHistoryDetails.promotionCodes
                                        }
                                    </span>
                                </div>
                            ) : null}
                        </div>
                    </div>

                    {ltoPurchaseOrderHistoryDetails.orderStatus ===
                        'Cancelled' &&
                        ltoPurchaseOrderHistoryDetails.cancelReason && (
                            <div className="cancel-reason">
                                <div className="card_conten">
                                    <div className="perOrder-cancel-title">
                                        {T('lto_history_detail_cancel_reason')}
                                    </div>
                                    <div className="perOrder-cancel-content">
                                        {
                                            ltoPurchaseOrderHistoryDetails.cancelReason
                                        }
                                    </div>
                                </div>
                            </div>
                        )}

                    <div className="order-confirm-item-block order-confirm-st-content">
                        <div className="st-title">
                            <span className="st-label">
                                {T('lto_history_list_st_number')}
                            </span>
                            <span>
                                {ltoPurchaseOrderHistoryDetails.shipToNumber}
                            </span>
                        </div>

                        <div className="st-name">
                            <label className="st-name-label">
                                {T('lto_history_list_st_name')}
                            </label>
                            <span>
                                {ltoPurchaseOrderHistoryDetails.stAlpha}
                            </span>
                        </div>

                        <div className="delivery-infor-double-noraml">
                            <label className="name-label">
                                {T('lto_history_list_delivery_information')}
                            </label>
                            <span className="name-value">
                                {
                                    ltoPurchaseOrderHistoryDetails.receiverAddressLine3
                                }
                                {
                                    ltoPurchaseOrderHistoryDetails.receiverAddressLine2
                                }
                                {
                                    ltoPurchaseOrderHistoryDetails.receiverAddressLine1
                                }
                            </span>
                        </div>

                        <div className="contact">
                            <div className="item">
                                <span>
                                    {ltoPurchaseOrderHistoryDetails.receiver}
                                </span>
                            </div>
                            <div className="item">
                                <span className="receiver-tel">
                                    {ltoPurchaseOrderHistoryDetails.receiverTel}
                                </span>
                            </div>
                        </div>

                        <div className="delivery-infor-double-noraml">
                            <label className="name-label">
                                {T(
                                    'lto_history_detail_order_information_sendto',
                                )}
                            </label>
                            <span className="name-value">
                                {this.getOrderReceiptEmail(
                                    ltoPurchaseOrderHistoryDetails.orderReceiptEmailList,
                                )}
                                {/* {
                                    ltoPurchaseOrderHistoryDetails.orderReceiptEmailList.length > 0 ? ltoPurchaseOrderHistoryDetails.orderReceiptEmailList.join(',') : ''
                                } */}
                            </span>
                        </div>
                    </div>
                    <div className="bt-info-content">
                        <div className="bt-title">
                            <span className="bt-number-label">
                                {T('lto_history_list_bt_number')}
                            </span>
                            <span>
                                {ltoPurchaseOrderHistoryDetails.billToNumber}
                            </span>
                        </div>

                        <div className="invoice-box">
                            <img
                                src={
                                    new URL(
                                        'Images/invoice-title.svg',
                                        import.meta.url,
                                    ).href
                                }
                                alt=""
                            />
                            <div className="invoice-info">
                                <div>
                                    {T('lto_history_list_invoice_heading')}
                                </div>
                                <div className="name">
                                    {
                                        ltoPurchaseOrderHistoryDetails.invoiceTitle
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="invoice-address-double-noraml">
                            <label className="name-label">
                                {T('lto_history_list_invoice_address')}
                            </label>
                            <span className="name-value">
                                {
                                    ltoPurchaseOrderHistoryDetails.invoiceReceiverAddressLine3
                                }
                                {
                                    ltoPurchaseOrderHistoryDetails.invoiceReceiverAddressLine2
                                }
                                {
                                    ltoPurchaseOrderHistoryDetails.invoiceReceiverAddressLine1
                                }
                            </span>
                        </div>

                        <div className="contact">
                            <div className="item">
                                <span>
                                    {
                                        ltoPurchaseOrderHistoryDetails.invoiceReceiver
                                    }
                                </span>
                            </div>
                            <div className="item">
                                <span className="receiver-tel">
                                    {
                                        ltoPurchaseOrderHistoryDetails.invoiceReceiverTel
                                    }
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="customer-confirmation-channel-content">
                        <div className="customer-confirmation-channel-title">
                            <span className="confirmation-channel-label">
                                {T(
                                    'lto_purchase_order_customer_confirmation_channel',
                                )}
                            </span>
                        </div>
                        <div className="customer-confirmation-channel-double-noraml">
                            <label className="name-label mobility-channel">
                                {T('lto_purchase_order_mobility')}
                            </label>
                        </div>
                        {ltoPurchaseOrderHistoryDetails.notificationMethods &&
                        ltoPurchaseOrderHistoryDetails.notificationMethods
                            .length > 0
                            ? ltoPurchaseOrderHistoryDetails.notificationMethods.map(
                                  (notificationItem, notificationIndex) => (
                                      <div
                                          className="customer-confirmation-channel-double-noraml"
                                          key={notificationIndex}>
                                          <label className="name-label">
                                              {notificationItem.method === 'sms'
                                                  ? T('phoneNumber')
                                                  : T('defaultEmail')}
                                          </label>
                                          <span className="name-value">
                                              {notificationItem.receiver}
                                          </span>
                                      </div>
                                  ),
                              )
                            : null}
                    </div>

                    {tfsOrders && tfsOrders.length > 0 && (
                        <div className="order-sku-cart-item">
                            <div className="products-title">
                                <div className="order-type-icon">
                                    <img
                                        src={
                                            new URL(
                                                'Images/online.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />
                                    <div className="order-type-label">
                                        {T('lto_history_detail_tfs_product')}
                                    </div>
                                </div>
                                {/* <span>
                                    {T('porduct_total_quantity', [
                                        this.getOrderQuantity(),
                                    ])}{' '}
                                    <b className="price price-font">
                                        <i className="rmb"></i>{' '}
                                        <b className="price-number">
                                            {util.toMoney(
                                                ltoPurchaseOrderHistoryDetails.totalPrice,
                                            ) || '0.00'}
                                        </b>
                                    </b>
                                </span> */}
                            </div>

                            {this.showOrderProducts(tfsOrders)}
                        </div>
                    )}

                    {scOrders && scOrders.length > 0 && (
                        <div className="order-sku-cart-item">
                            <div className="products-title">
                                <div className="order-type-icon">
                                    <img
                                        src={
                                            new URL(
                                                'Images/sp-icon.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />
                                    <div className="order-type-label">
                                        {ltoPurchaseOrderHistoryDetails.scName}
                                    </div>
                                </div>
                                {/* <span>
                                    {T('porduct_total_quantity', [
                                        this.getOrderQuantity(),
                                    ])}{' '}
                                    <b className="price price-font">
                                        <i className="rmb"></i>{' '}
                                        <b className="price-number">
                                            {util.toMoney(
                                                ltoPurchaseOrderHistoryDetails.totalPrice,
                                            ) || '0.00'}
                                        </b>
                                    </b>
                                </span> */}
                            </div>
                            {this.showOrderProducts(scOrders)}
                        </div>
                    )}
                </div>

                <div className="footer-warp">
                    <div className="pre-purchase-orderHistory-details-footer container-max-width is-fixed">
                        <div className="order-history-price-details-footer">
                            <div className="total-num">
                                {T('lto_history_detail_total_quantity', [
                                    this.getOrderQuantity(),
                                ])}{' '}
                            </div>
                            <div className="details-footer-right-container">
                                <div className="total-price">
                                    {T('lto_history_detail_total_price')}:
                                    <b className="price price-font">
                                        <i className="rmb"></i>{' '}
                                        <b className="price-number">
                                            {ltoPurchaseOrderHistoryDetails.totalPrice
                                                ? util.toMoney(
                                                      ltoPurchaseOrderHistoryDetails.totalPrice,
                                                  )
                                                : '0.00'}
                                        </b>
                                    </b>
                                </div>
                            </div>
                        </div>

                        {ltoPurchaseOrderHistoryDetails.orderStatus ===
                        'To_Be_Confirmed' ? (
                            <div className="resend-confirm-column">
                                <BasicButton
                                    className="resend-cancel-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={(event) =>
                                        this.openCancelOrderDialog(
                                            ltoPurchaseOrderHistoryDetails,
                                            event,
                                        )
                                    }>
                                    {T('lto_history_list_cancel_notification')}
                                </BasicButton>
                                <BasicButton
                                    className="resend-confirm-btn"
                                    testid="preorder-history-resend-notification-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={(event) =>
                                        this.resendNotification(
                                            ltoPurchaseOrderHistoryDetails,
                                            event,
                                        )
                                    }>
                                    {T('lto_history_list_notification')}
                                </BasicButton>
                            </div>
                        ) : null}
                    </div>
                </div>

                <Dialog
                    dialogDidClose={this.closeNotificationDialog}
                    opened={isOpenNotificationDialog}
                    options={{bgClickClose: true}}>
                    <div className="lto-detail-resend-dialog">
                        <h5 className="lto-detail-resend-dialog-title text-center">
                            {T('lto_history_list_resend_notification')}
                        </h5>
                        <div className="lto-detail-resend-dialog-desc text-center">
                            <div className="confirmation-channel-option">
                                <Checkbox
                                    checked={isMobilityNotification}
                                    onChange={this.handleCustomerConfirmationChannel.bind(
                                        this,
                                        'isMobilityNotification',
                                        isMobilityNotification,
                                    )}
                                    disabled={true}
                                    className="checkbox-button"
                                />
                                <span className="all-selected-title">
                                    {T('lto_purchase_order_mobility')}
                                </span>
                            </div>
                            <div className="confirmation-channel-option">
                                <Checkbox
                                    checked={isSMS}
                                    onChange={this.handleCustomerConfirmationChannel.bind(
                                        this,
                                        'isSMS',
                                        isSMS,
                                    )}
                                    className="checkbox-button"
                                />
                                <span className="all-selected-title">
                                    <label className="default-email-label">
                                        {T('phoneNumber')}
                                    </label>
                                    <Select
                                        className="select"
                                        value={phoneNumberId}
                                        placeholder={T(
                                            'select_customer_confirmation_channel_phone_number',
                                        )}
                                        data={phoneNumberList}
                                        displayKey="name"
                                        valueKey="id"
                                        onChange={this.handleSelectChange}
                                        isDialog={true}
                                        options={{
                                            icon: {
                                                show: true,
                                                color: '#E82D38',
                                            },
                                        }}
                                    />
                                </span>
                            </div>
                            <div className="confirmation-channel-option">
                                <Checkbox
                                    checked={isEmail}
                                    onChange={this.handleCustomerConfirmationChannel.bind(
                                        this,
                                        'isEmail',
                                        isEmail,
                                    )}
                                    className="checkbox-button"
                                />
                                <div className="all-selected-title">
                                    <label className="default-email-label">
                                        {T('defaultEmail')}
                                    </label>
                                    <div className="default-email">
                                        {defaultEmail}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tag-upload-btn-container">
                            <BasicButton
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={
                                    this.closeNotificationDialog
                                }>
                                {T('cancel')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="receive-confirm-btn"
                                loading={loading}
                                onClickOfSingleTap={
                                    this.resendNotificationHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={cancelOrderDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('cancelOrderDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="cancel-order-dialog">
                        <h5 className="cancel-order-dialog-title text-center">
                            {T('order_confirm_cancel_order')}
                        </h5>
                        <p className="cancel-order-dialog-desc text-center">
                            <BasicTextArea
                                title={'lto_history_list_cancel_reason'}
                                placeholder={
                                    'lto_history_list_cancel_reason_placeholder'
                                }
                                defalutValue={currentCancelReason}
                                inputValid={this.handleOnInput}
                                isSearchChange={true}
                                rows={3}
                                type="text"
                                value={currentCancelReason}
                            />
                        </p>
                        <div className="dialog-footer-btn">
                            <BasicButton
                                type="primary"
                                className="cancel-order-confirm-btn"
                                onClickOfSingleTap={this.closeCancelOrder}>
                                {T('btn_action_cancel')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="confirm-cancel-order-btn"
                                onClickOfSingleTap={this.cancelOrderHandle}>
                                {T('order_confirm')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {ltoPurchaseOrder} = state;
    return {
        ltoPurchaseOrderHistoryDetails:
            ltoPurchaseOrder.ltoPurchaseOrderHistoryDetails,
    };
};

const mapDispatchToProps = {
    getLtoPurchaseOrderHistoryDetails,
    getNotificationChannel,
    reminderNotification,
    openNotification,
    cancelOrder,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LtoPurchaesOrderHistoryDetails);
